/*!
 * pmk167
 * (c) 2019 kirsites <kirsites@gmail.com>
 * licensed under the MIT license
 */

(function () {

    const map = document.querySelector('.map-section__container');

    if (!map) return;

    const addr1 = [55.751994068967015, 37.758984999999974];
    const addr2 = [55.79217406895107, 37.89350799999999];

    let center = [
        addr1[0] + ((addr2[0] - addr1[0]) / 2),
        addr1[1] + ((addr2[1] - addr1[1]) / 2),
    ];

    ymaps.ready(function () {
        let myMap = new ymaps.Map(map, {
            center: center,
            zoom  : 12,
        });

        let myPlacemark1 = new ymaps.GeoObject({
            geometry  : { type: 'Point', coordinates: addr1 },
            properties: { iconContent: 'Офис в Москве' },
        }, { preset: 'islands#darkOrangeStretchyIcon', draggable: false });

        let myPlacemark2 = new ymaps.GeoObject({
            geometry  : { type: 'Point', coordinates: addr2 },
            properties: { iconContent: 'Офис в Балашихе' },
        }, { preset: 'islands#darkOrangeStretchyIcon', draggable: false });

        myMap.geoObjects
            .add(myPlacemark1)
            .add(myPlacemark2)
        ;
    });

})();